import React, { createContext, useContext, useReducer, useEffect } from "react";
import { useState } from "react";
import { USER_ID, AUTH_TOKEN } from "constants/AuthConstant";
import { API_BASE_URL } from "configs/AppConfig";
import { isValidToken } from "services/ApiService";
import { useDispatch } from "react-redux";
import { signOut } from "store/slices/authSlice";

export const UserDataContext = createContext();

const initialState = {
  users: [],
  newRoles: [],
  userPermissions: [],
  isLoading: false,
};
const userReducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_PERMISSIONS":
      return {
        ...state,
        users: action.payload.users,
        newRoles: action.payload.newRoles,
        userPermissions: action.payload.userPermission,
      };
    case "UPDATE_LOADING":
      return { ...state, isLoading: action.payload };
    default:
      return state;
  }
};
export const updateUserPermissions = (dispatch, userPermissions) => {
  dispatch({
    type: "UPDATE_PERMISSIONS",
    payload: userPermissions,
  });
};
export const setLoading = (dispatch, isLoading) => {
  dispatch({
    type: "UPDATE_LOADING",
    payload: isLoading,
  });
};

export function UserDataProvider({ children }) {
  const [userData, dispatch] = useReducer(userReducer, initialState);
  const [error, setError] = useState(null);
  const dispatch_ = useDispatch();
  const updateUserPermissionsWithContext = (userPermissions) => {
    updateUserPermissions(dispatch, userPermissions);
  };
  const setLoadingWithContext = (isLoading) => {
    setLoading(dispatch, isLoading);
  };
  const userId = localStorage.getItem(USER_ID);
  const token = localStorage.getItem(AUTH_TOKEN);
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (userId) {
          const response = await fetch(`${API_BASE_URL}/Auth/GetUserDataById`, {
            method: "POST",
            body: JSON.stringify(userId),
            headers: {
              "Content-type": "application/json; charset=UTF-8",
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.ok) {
            const data = await response.json();
            if (data.users) {
              dispatch({ type: "UPDATE_PERMISSIONS", payload: data });
            }
          } else if (response.status == "401") {
            dispatch_(signOut());
          }
        }
      } catch (error) {
        console.error("Error:", error);
        setError(error);
      } finally {
        //setLoading(false);
      }
    };
    // if (isValidToken(token)) {
    //   fetchData();
    // } else {
    //   dispatch_(signOut());
    // }
    fetchData();
  }, []);

  return (
    <UserDataContext.Provider
      value={{
        ...userData,
        updateUserPermissions: updateUserPermissionsWithContext,
        setLoading: setLoadingWithContext,
      }}
    >
      {children}
    </UserDataContext.Provider>
  );
}
export function useUserData() {
  const context = useContext(UserDataContext);
  if (!context) {
    throw Error("useUserData must be used within a UserDataProvider");
  }
  return context;
}
//Function to get permissions for screen by passing screen path and userData;
export const getScreenPermission = (userData, path) => {
  const { companyId, factoryId, newRoles, userPermissions, users } = userData;
  var permissions = {};
 
  if (users.length > 0) {
    if (users[0].email == "super@admin.com") {
      permissions = {
        canAdd: true,
        canEdit: true,
        canDelete: true,
        canView: true,
      };
    } else {
      const roleId = newRoles.find((x) => x.path == path)?.roleId;
      permissions = roleId && userPermissions.find((x) => x.roleId == roleId);
      permissions = permissions || {
        canAdd: false,
        canEdit: false,
        canDelete: false,
        canView: false,
      };
    }
  }

  return permissions;
};
